import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode, CSSProperties } from 'react';
import styled from 'styled-components';
import { BouSvgIcon } from '../bou-svg-icon';

/**
 * Note that there is no prop for text size. You should
 * rather use styled(BouTextAndIcon)`...` to define font size.
 */
interface Props {
  text: string | ReactNode;

  /**
   * Font awesome icon (only for temporary use)
   */
  faIcon?: IconDefinition;

  /**
   * Streamline icon
   */
  slIcon?: JSX.Element;

  /**
   * Fully custom icon
   */
  icon?: ReactNode;

  /**
   * Icon size, defaults to 1.1em
   *
   * Tip: usually you should use em units
   */
  iconSize?: string;

  fixIconWidth?: boolean;

  reverse?: boolean;
  fontWeight?: string;
  onClick?: () => void;
  style?: CSSProperties;
  className?: string;
}

export function BouTextAndIcon(props: Props) {
  const iconSize = props.iconSize || '1.1em';
  const fontWeight = props.fontWeight || 'bold';
  const reverse = !!props.reverse;

  function getIcon() {
    if (props.slIcon) {
      return <BouSvgIcon icon={props.slIcon} size={iconSize} />;
    } else if (props.faIcon) {
      return <StyledIcon style={{ fontSize: iconSize }} icon={props.faIcon} />;
    } else {
      return <span style={{ fontSize: iconSize }}>{props.icon}</span>;
    }
  }

  function getIconWithWrap() {
    if (props.fixIconWidth) {
      return <IconWrap>{getIcon()}</IconWrap>;
    }
    return getIcon();
  }

  return (
    <Root onClick={props.onClick} className={props.className} reverse={reverse} style={props.style}>
      {getIconWithWrap()}
      <Text reverse={reverse} fontWeight={fontWeight}>
        {props.text}
      </Text>
    </Root>
  );
}

const StyledIcon = styled(FontAwesomeIcon)`
  width: 2em;
`;

const iconWrapperWidth = 1.25;
const textMargin = 0.7;

const IconWrap = styled.div`
  width: ${iconWrapperWidth}em;
  text-align: center;
`;

const Root = styled.div<{ reverse: boolean }>`
  flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};
  display: flex;
  align-items: center;
`;

const Text = styled.div<{ reverse: boolean; fontWeight: string }>`
  display: block;
  font-weight: ${props => props.fontWeight};
  margin-left: ${props => (props.reverse ? '0' : `${textMargin}em`)};
  margin-right: ${props => (props.reverse ? `${textMargin}em` : '0')};
`;
